import { makeStyles } from '@material-ui/core';

export const useConnectorItemStyles = makeStyles(() => ({
  connectMenuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 12px',
    alignItems: 'center',
    gap: '2px',
    flex: 1,
    borderRadius: '12px',
    border: '1px solid #34353B',
    cursor: 'pointer',

    '&:hover': {
      background: 'rgba(255, 255, 255, 0.07)',
      '& > span': {
        background: '#B17640',
      },
    },
    '& > span': {
      fontSize: '14px',
      lineHeight: '24px',
      whiteSpace: 'nowrap',
      background: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '48px',
      padding: '4px 12px',
      alignItems: 'center',
      height: '32px',
      color: '#FAFAFA',
    },
  },
  notInstall: {
    color: '#ABABAB',
    '& > img': {
      opacity: '0.5',
    },
    '& > span': {
      color: '#FAFAFA',
    },
    '& > span > img': {
      opacity: 1,
    },
  },
  walletItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',

    color: '#FFF',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '40px',
    '& > img': {
      maxWidth: '28px',
      maxHeight: '28px',
    },
  },
  recommended: {
    color: '#71DD5F',
    fontSize: '12px',
    lineHeight: '16px',
    marginTop: 2,
  },
  walletItemContent: {
    lineHeight: '16px',
    display: 'flex',
    flexDirection: 'column',
  },
}));
